import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frontpictures',
  templateUrl: './frontpictures.component.html',
  styleUrls: ['./frontpictures.component.css']
})
export class FrontpicturesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
